import Parse from "parse";

import type { Category } from "./Category";

export interface QuestionAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  audio: Parse.File;
  category?: Category | undefined;
  name: string;
  synthetic: boolean;
}

export class Question extends Parse.Object<QuestionAttributes> {
  static className: string = "Antiscam_Question";

  constructor(data?: Partial<QuestionAttributes>) {
    super("Antiscam_Question", data as QuestionAttributes);
  }

  get audio(): Parse.File {
    return super.get("audio");
  }
  set audio(value: Parse.File) {
    super.set("audio", value);
  }

  get category(): Category | undefined {
    return super.get("category");
  }
  set category(value: Category | undefined) {
    super.set("category", value);
  }

  get name(): string {
    return super.get("name");
  }
  set name(value: string) {
    super.set("name", value);
  }

  get synthetic(): boolean {
    return super.get("synthetic");
  }
  set synthetic(value: boolean) {
    super.set("synthetic", value);
  }
}

Parse.Object.registerSubclass("Antiscam_Question", Question);
